import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'react-i18next'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { useParams } from 'libs/router'
import { apiRoutes } from 'config/apiRoutes'
import axios from 'libs/fetch'
import { queryKeys } from 'config/queryKeys'

export const useConfirmProductMutation = () => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const params = useParams()
	const queryClient = useQueryClient()

	const { mutate: confirmProductMutation, isPending: isConfirmProductMutationLoading } =
		useMutation({
			mutationFn: () => {
				return axiosPrivate.post(apiRoutes.productConfirm(params.id as string))
			},
			onSuccess: () => {
				queryClient.invalidateQueries({ queryKey: queryKeys.products.detail(params.id as string) })
				useToast({
					type: 'success',
					message: t('Product confirmed')
				})()
			},
			onError: (error) => {
				if (axios.isAxiosError(error)) {
					for (const [_key, value] of Object.entries(error?.response?.data)) {
						useToast({
							type: 'error',
							message: t(value as string)
						})()
					}

					return
				}
				useToast({
					type: 'error',
					message: t('Something went wrong')
				})()
			}
		})

	const { mutate: unconfirmProductMutation, isPending: isUnconfirmProductMutationLoading } =
		useMutation({
			mutationFn: () => {
				return axiosPrivate.post(apiRoutes.productUnconfirm(params.id as string))
			},
			onSuccess: () => {
				queryClient.invalidateQueries({ queryKey: queryKeys.products.detail(params.id as string) })
				useToast({
					type: 'success',
					message: t('Product unconfirmed')
				})()
			},
			onError: (error) => {
				if (axios.isAxiosError(error)) {
					for (const [_key, value] of Object.entries(error?.response?.data)) {
						useToast({
							type: 'error',
							message: t(value as string)
						})()
					}

					return
				}
				useToast({
					type: 'error',
					message: t('Something went wrong')
				})()
			}
		})

	return {
		confirmProductMutation,
		unconfirmProductMutation,
		isConfirmProductMutationLoading,
		isUnconfirmProductMutationLoading
	}
}
